<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <!-- <div>{{ '这是简易账务输入框' }}</div> -->
    <el-row>
      <el-col :span="3" class="item-label"><span class="hl-red">保费</span></el-col>
      <el-col :span="3">
        <el-input v-model="input_premium" placeholder="请输入保费" @input="inputPremium" class="w-100" ></el-input>
      </el-col>
      <el-col :span="18" class="item-label">
        <!-- <el-button type="primary" size="mini" @click="addServiceContent">增加产品</el-button> -->
        <el-button type="primary" size="mini" @click="saveData">保存</el-button></el-col>
    </el-row>

    <el-row>
      <el-col :span="3" class="item-label"><span class="hl-red">险种</span></el-col>
      <el-col :span="21">
        <el-cascader placeholder="保险公司 / 所属分公司 / 险种 / 佣金比例"
                     v-model="settingValue"
                     :options="settingOptions"
                     @change="handleSettingChange" class="w-100"></el-cascader>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="3" class="item-label"><span class="hl-red">佣金比例</span></el-col>
      <el-col :span="3">
        <el-input-number v-model="input_commission_2agent_rate" placeholder="请输入佣金比例" :disabled="settingValue.length == 0"
            :min=0 :max="max_commission_2agent_rate" :controls="false" @input="inputCommission2AgentRate" class="w-100" />
      </el-col>
    </el-row>

    <!-- 汇总表格   -->
    <el-divider></el-divider>
    <el-row>
      <table class="summary_table" >
        <tr>
          <td class="summary_title p25">保险公司</td>
          <td class="summary_title ">险种</td>
          <td class="summary_title p9">保费</td>
          <td class="summary_title p9">手续费比例</td>
          <td class="summary_title p9">手续费税率</td>
          <td class="summary_title p9">开票比例</td>
          <td class="summary_title p9">不开票比例</td>
          <td class="summary_title p9">佣金比例</td>
          <td class="summary_title p8"></td>
        </tr>
        <tr>
          <td class="summary_field">{{fin_info.insurance_company}}</td>
          <td class="summary_field" rowspan="3">{{fin_info.insurance_type}}</td>
          <td class="summary_field">{{fin_info.premium}}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{fin_info.commission_2agent_rate}}</td>
          <td class="summary_field" rowspan="3"></td>
        </tr>
        <tr>
          <td class="summary_title">保险公司所属分公司</td>
          <td class="summary_title">公司收入</td>
          <td class="summary_title">手续费</td>
          <td class="summary_title">税金</td>
          <td class="summary_title">开票金额</td>
          <td class="summary_title">不开票金额</td>
          <td class="summary_title">佣金支出</td>
        </tr>
        <tr >
          <td class="summary_field">{{fin_info.insurance_company_branch_office}}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{ '——' }}</td>
          <td class="summary_field">{{fin_info.commission_2agent}}</td>
        </tr>
      </table>
    </el-row>
  </el-dialog>
</template>

<script>
import { fetchSettingAll, fetchSettingSimple } from '@/api/billing'
export default {
  name: 'service-info-input',
  props: {
    is_disabled: { default: true },
    insurance_company:{ default:'' },
    insurance_company_branch_office:{ default:'' },
    insurance_type:{default:''},
    commission_2agent_rate:{default:0},
    premium:{default:0},
    commission_2agent:{default:0},
    services:{default: function() {return []}},
  },
  data() {
    return {
      disabled: this.is_disabled,
      dialogVisible: false,
      // 保险公司,险种,手续费比例,佣金比例选项
      settingOptions:[],
      settingValue: [],

      selected_idx: null,
      fin_info: {
        policy_number: this.policy_number,
        insurance_company: this.insurance_company,
        insurance_company_branch_office: this.insurance_company_branch_office,
        insurance_type: this.insurance_type,
        commission_rate: this.commission_rate,
        commission_2agent_rate: this.commission_2agent_rate,
        vat_rate: this.vat_rate,
        premium: this.premium,
        commission: this.commission,
        commission_2agent: this.commission_2agent,
        vat: this.vat,
        commission_2yihe: this.commission_2yihe,
        invoice_rate: this.invoice_rate,
        un_invoice_rate: this.un_invoice_rate,
        invoice: this.invoice,
        un_invoice: this.un_invoice,
        services: {},
        is_equal_premium: 0,
        is_equal_commission_rate: 0,
      },
      input_commission_2agent_rate: 0,
      max_commission_2agent_rate: 0,
      input_premium: this.premium,
      input_commission_2agent: 0,
      input_content_style: '',
      service_contents:[],
    }
  },
  watch: {
    'is_disabled': function (val){
      this.disabled = val
    },

    'insurance_company': function(val){
      this.fin_info.insurance_company = val
    },
    'insurance_company_branch_office': function(val){
      this.fin_info.insurance_company_branch_office = val
    },
    'insurance_type': function(val){
      this.fin_info.insurance_type = val
    },
    'commission_rate': function(val){
      this.fin_info.commission_rate = val
    },
    'commission_2agent_rate': function(val){
      this.fin_info.commission_2agent_rate = val
    },
    'vat_rate': function(val){
      this.fin_info.vat_rate = val
    },
    'premium': function(val){
      this.fin_info.premium = val
      this.input_premium = val
    },
    'commission': function(val){
      this.fin_info.commission = val
    },
    'commission_2agent': function(val){
      this.fin_info.commission_2agent = val
    },
    'vat': function(val){
      this.fin_info.vat = val
    },
    'commission_2yihe': function(val){
      this.fin_info.commission_2yihe = val
    },
    'invoice_rate': function(val){
      this.fin_info.invoice_rate = val
    },
    'un_invoice_rate': function(val){
      this.fin_info.un_invoice_rate = val
    },
    'invoice': function(val){
      this.fin_info.invoice = val
    },
    'un_invoice': function(val){
      this.fin_info.un_invoice = val
    },
    'services': function(val){
      this.service_contents = val
    },
  },
  created() {
    this.loadData()
  },
  methods:{
    loadData(){
      let p = []
      p.push(fetchSettingSimple())
      Promise.all(p)
          .then(res => {
            // 获取费率设置选项
            this.settingOptions= res[0]
          })
          .catch(error => {
            this.$message.error(error)
          })
    },
    showDialog(){
      this.dialogVisible = true
    },

    // 选项变更操作
    handleSettingChange(value) {
      console.log(this.fin_info)
      // this.changeIsGroupInsurance(value)
      if(value[0] !== null && value[0] !== undefined){
        this.fin_info.insurance_company = value[0]
      }
      if(value[1] !== null && value[1] !== undefined){
        this.fin_info.insurance_company_branch_office = value[1]
      }
      if(value[2] !== null && value[2] !== undefined){
        this.fin_info.insurance_type = value[2]
      }
      if(value[3] !== null && value[3] !== undefined){
        this.input_commission_2agent_rate = value[3]
        this.max_commission_2agent_rate = Number((Number(value[3]) + 0.01).toFixed(2))
      }
      this.flushInput()
      this.updateFinInfo()
    },

    resetFinInfo(){
      this.fin_info.insurance_company = ''
      this.fin_info.insurance_company_branch_office = ''
      this.fin_info.insurance_type = ''
      this.fin_info.commission_rate = 0
      this.fin_info.commission_2agent_rate = 0
      this.fin_info.vat_rate = 0
      this.fin_info.premium = 0
      this.fin_info.commission = 0
      this.fin_info.commission_2agent = 0
      this.fin_info.vat = 0
      this.fin_info.commission_2yihe = 0
      this.fin_info.invoice_rate = 0
      this.fin_info.un_invoice_rate = 0
      this.fin_info.invoice = 0
      this.fin_info.un_invoice = 0
      this.fin_info.services = this.service_contents
    },
    updateFinInfo() {
      // console.log(this.input_premium)
      // console.log(this.input_commission_2agent_rate)

      this.fin_info.premium = parseFloat(this.input_premium)
      this.fin_info.commission_2agent_rate = parseFloat(this.input_commission_2agent_rate)
      this.fin_info.commission_2agent = parseFloat((this.input_premium * this.input_commission_2agent_rate).toFixed(2))
    },
    saveData() {
      this.$emit('change', this.fin_info)
      this.dialogVisible = false
    },

    // 更新佣金数据
    flushInput(field='un_invoice_rate') {
      let premium = 0
      if (! isNaN(parseFloat(this.input_premium))){
        premium = parseFloat(this.input_premium)
      }

      let commission_2agent_rate = parseFloat(this.input_commission_2agent_rate)
      if (! isNaN(parseFloat(this.input_commission_2agent_rate))){
        commission_2agent_rate = parseFloat(this.input_commission_2agent_rate)
      }

      let commission_2agent = (premium * commission_2agent_rate).toFixed(2)

      if (field !== 'premium') {
        this.input_premium = premium
      }

      if (field !== 'commission_2agent_rate') {
        this.input_commission_2agent_rate = commission_2agent_rate
      }

      if (field !== 'commission_2agent') {
        this.input_commission_2agent = commission_2agent
      }
    },

    // 数据返回操作
    // inputInsuranceCompany(val){
    //   this.fin_info.insurance_company = val
    //   this.updateFinInfo()
    // },
    // inputInsuranceCompanyBranchOffice(val){
    //   this.fin_info.insurance_company_branch_office = val
    //   this.updateFinInfo()
    // },
    // inputInsuranceType(val){
    //   this.fin_info.insurance_type = val
    //   this.updateFinInfo()
    // },
    inputCommission2AgentRate(val){
      this.flushInput('commission_2agent_rate')
      this.updateFinInfo()
    },
    inputPremium(val){
      this.flushInput('premium')
      this.updateFinInfo()
    },

    // 数据交验操作
    validate(){
      let result = []
      if(this.fin_info.insurance_company === '' || this.fin_info.insurance_company === null) result.push('经办保险公司')
      if(this.fin_info.insurance_company_branch_office === '' || this.fin_info.insurance_company === null) result.push('所属分公司')
      if(this.fin_info.insurance_type === '' || this.fin_info.insurance_company === null ) result.push('险种')
      if(this.fin_info.commission_2agent_rate === '' || this.fin_info.commission_2agent_rate === null || this.fin_info.commission_2agent_rate === 0) result.push('佣金支出比例')
      if(this.fin_info.premium === '' || this.fin_info.premium === null || this.fin_info.premium === 0) result.push('保费')
      return result
    }
  }
}
</script>

<style scoped>
.service_table {
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
}
.service_table_title {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  background-color: #19aa8d;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
}
.service_table_title_sec {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  background-color: #86e0c5;
  vertical-align: center;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
}
.service_table_field {
  border-left: 1px solid #86e0c5;
  border-right: 1px solid #86e0c5;
  vertical-align: center;
  text-align: center;
}

.summary_table {
  margin-left: 0%;
  margin-right: 0%;
  width: 100%;
}
.summary_title {
  border: 1px solid #1d1d1d;
  text-align: center;
  font-weight: bold;
  background-color: #1d1d1d;
  color: #f9fafc;
}
.summary_field {
  border: 1px solid #1d1d1d;
  vertical-align: center;
  text-align: center;
}

.item-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hl-red {
  color: red;
}
.active {
  background-color: #444141;
  color: #FFFFFF;
}
>>> .el-radio-group{
  margin: 10px;
}
>>> .el-dialog {
  width:96%
}

.p25{
  width: 25%;
}
.p10{
  width: 10%;
}
.p9{
  width: 9%;
}
.p8{
  width: 8%;
}
</style>
